import { useMemo } from "react";
import { AdminWordService } from "../lib/AdminWordService";
import { createAdminWordService } from "../lib/AdminWordServiceFactory";

/**
 * React hook for getting a properly bound AdminWordService instance
 */
export const useAdminWordService = (
  type: "firebase" | "supabase" = "supabase"
): AdminWordService => {
  return useMemo(() => {
    if (type === "firebase") {
      return createAdminWordService.firebase();
    } else {
      return createAdminWordService.supabase();
    }
  }, [type]);
};
